var React = require('react');

function ModernUiUx (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#12EBAE","d":"M-398.9,266.8l-26.6-17.5c-0.7-0.4-1.5,0-1.5,0.8v34c0,0.4,0.2,0.7,0.5,0.9l27.1,15.1c0.3,0.2,0.7,0.2,1,0\n\t\t\tl26.9-15.2c0.3-0.2,0.5-0.5,0.5-0.9v-33.9c0-0.8-0.9-1.3-1.6-0.8L-398.9,266.8z M-375,280.1l-20-11l20-13.3V280.1z M-402.8,269.1\n\t\t\tl-20.2,11v-24.4L-402.8,269.1z M-398.9,295.7l-22-12.2l22-12l21.8,12L-398.9,295.7z"})));
}

ModernUiUx.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"-427 249.2 56 51.1","enableBackground":"new -427 249.2 56 51.1","xmlSpace":"preserve","height":"62px"};

module.exports = ModernUiUx;

ModernUiUx.default = ModernUiUx;
